import { Popup, TextArea } from "devextreme-react";
import { Position } from "devextreme-react/popup";
import { FormEvent, useRef } from "react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { CalculateGrid } from "@redux/uq/uq-actions";
import CustomButton from "@components/CustomButton";
import { closePopup, getValue } from "@helpers/DxHelper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { TextAreaRef } from "devextreme-react/cjs/text-area";

type Props = { updateRef: any; gridSet?: any };

export default function UpdatePopup({ updateRef, gridSet }: Props) {
  const { updateCell: data, indexShift } = useAppSelector((state) => state.uq);
  const dispatch = useAppDispatch();
  const noteRef = useRef<TextAreaRef>(null);

  function saveHandler(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const note = getValue(noteRef);
    const newGrid = structuredClone(gridSet);
    const index = data.rowIndex + indexShift;

    newGrid[index][data.col] = {
      value: data.value,
      defaultValue: data.defaultValue,
      manualChange: data.manualChange,
      note,
    };

    dispatch(CalculateGrid(index, newGrid));
    closePopup(updateRef);
  }

  return (
    <Popup
      width={369}
      height="fit"
      minHeight={278}
      ref={updateRef}
      hideOnOutsideClick={true}
      showTitle={false}
      onShown={() => {
        noteRef.current?.instance().option("value", data.note ?? "");

        setTimeout(() => {
          noteRef.current?.instance().element()?.focus();
        }, 100);
      }}
    >
      <Position at="top" my="bottom" of={data.id ? `#${data.id}` : undefined} collision="fit" />
      <form onSubmit={saveHandler}>
        <div className="flex flex-col gap-5">
          <TextArea
            ref={noteRef}
            label="Note"
            labelMode="static"
            width={"100%"}
            height={144}
            stylingMode="outlined"
          />
        </div>
        <CustomButton className="mt-7 w-full" text="Save Changes" variant="primary" />
      </form>
    </Popup>
  );
}
